// Shared protocol contains identity only: never app content, URLs or credentials.
export const CUSTOMER_TOOLS_SELECT = 'apolis:customer-tools:select';
export const CUSTOMER_TOOLS_STATE = 'apolis:customer-tools:state';
export const CUSTOMER_TOOLS_REQUEST = 'apolis:customer-tools:request';

export function positiveId(value) {
  const text = String(value ?? '');
  return /^[1-9]\d*$/.test(text) ? text : null;
}

export function scopeKey(accountId, conversationId) {
  const account = positiveId(accountId);
  const conversation = positiveId(conversationId);
  return account && conversation ? `${account}:${conversation}` : null;
}

export function appChoices(apps) {
  const seen = new Set();
  return (Array.isArray(apps) ? apps : []).flatMap(app => {
    const id = positiveId(app?.id);
    if (!id || seen.has(id) || typeof app.title !== 'string') return [];
    seen.add(id);
    return [{ id, title: app.title }];
  });
}

export function selectionIndex(apps, appId) {
  const id = positiveId(appId);
  if (!id) return -1;
  return (Array.isArray(apps) ? apps : []).findIndex(app => positiveId(app?.id) === id);
}

export function acceptsSelection(request, state, apps) {
  return Boolean(
    state?.scope && state?.session && request?.scope === state.scope &&
    request?.session === state.session && selectionIndex(apps, request?.appId) >= 0
  );
}
